import { observable } from 'mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

export class QualtricsStore extends Store {
  public static DEFAULTS = {
    zoneId: null
  };

  @observable
  public zoneId: string;

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
